// Brief 85 §2's held-back dedup — the address block, declared once.
//
// Street / Postal Code + City / Country appeared FIVE times, byte-identical:
//   OpposingCounselModal.tsx:88-101
//   ExpertModal.tsx:89-102
//   MediatorModal.tsx:91-104
//   ArbiterModal.tsx:91-104
//   AdditionalPartyModal.tsx:98-111
// sha256 c03f3ff7d2897d3b30feb1dfb21efe46176ec6cb634b9d80d50dc165cd442385 — one hash across all five, so
// check 1b diffs to ZERO hunks and no parameter is owed. The body below is that
// slice, verbatim, indentation included; only the fragment, the Props and the
// signature are new.
//
// A SIXTH COPY EXISTS AND IS DELIBERATELY NOT FOLDED IN. ClientModal carries
// the same four fields, but its Country <FieldSelect> is wrapped in a
// <div className="field-row"> it SHARES with a Language field, so the region is
// a different subtree — not a value difference a parameter could carry. Per the
// standard, a hunk with no parameter is not a parameter: it is reported, not
// absorbed, and not approximated to fit. ClientModal keeps its own copy and is
// a declared orphaned survivor of this collapse.
//
// This is the SEPARATE, LATER commit brief 85 §2 requires — the eleven modals
// moved verbatim with their copies intact first, and nothing was collapsed in
// the same commit as a move.

import FieldSelect from "../FieldSelect";
import type { FieldSelectOption } from "../FieldSelect";
import type { TaxList, TFn } from "../../lib/taxonomyTypes";
import type { makeModalFields } from "../modalFields";

type Vocab = ReturnType<typeof makeModalFields>;

type Props = {
  F: Vocab["F"];
  _fl: Vocab["_fl"];
  countriesList: readonly FieldSelectOption[];
  countryEntries: TaxList;
  form: { country?: string | null };
  t: TFn;
  updateField: (k: string, v: string) => void;
};

export default function AddressFields({
  F,
  _fl,
  countriesList,
  countryEntries,
  form,
  t,
  updateField,
}: Props) {
  return (
    <>
                {F("Street", "street")}
                <div className="field-row">
                  {F("Postal Code", "postalCode")}
                  {F("City", "city")}
                </div>
                <FieldSelect
                  label={_fl("Country")}
                  value={form.country}
                            onChange={(v) => updateField("country", v)}
                  options={[["", `— ${t("common.none", { fallback: "None" })} —`], ...countriesList]}
                  searchable
                  entries={countryEntries}
                  t={t}
                />
    </>
  );
}
